import { FC, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { TextField } from '@material-ui/core';
import styled from 'styled-components';
import { get } from 'lodash';
import {
  Container,
  FormWrapper,
  MessageContainer,
} from 'components/FirmReferenceForm/styled-components';
import InfoIcon from 'images/info-icon.svg';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerFeeNote/messages';

export interface FirmReferenceFormProps {
  intl: IntlShape;
  firmReference: string;
  message?: string;
  formInputLabel: string;
  formInputName: string;
  validationButtonTitle: string;
  setIsDialogOpenFirmReference?: Function;
  title?: string;
  isFeeNoteGenerated?: boolean;
  isForm?: boolean;
  feeNote?: any;
  isPronoucing?: boolean;
  isAssignmentDateValid?: boolean;
  isJom?: boolean;
  judiciaryProcessId: any;
  lawyerFirmReference?: any;
  assignment: any;
}

const FirmReferenceForm: FC<FirmReferenceFormProps> = props => {
  const {
    firmReference,
    message,
    formInputLabel,
    formInputName,
    validationButtonTitle,
    setIsDialogOpenFirmReference = () => {},
    title = '',
    isFeeNoteGenerated,
    isForm = false,
    feeNote,
    isPronoucing,
    isAssignmentDateValid = true,
    lawyerFirmReference = '',
  } = props;

  const [newFirmReference, setNewFirmReference] = useState(firmReference);

  const FirmReferenceInfoBloc = styled.div`
    padding: 16px 16px 24px 16px;
    border-radius: 8px;
    background: var(--primary-100, #e6f1fa);
    margin-top: 10px;
    margin-bottom: 10px;
  `;

  const handleChangeFirmReference = (
    event: React.ChangeEvent<{
      value: string;
    }>,
  ) => setNewFirmReference(event.target.value);
  return (
    <>
      {!isAssignmentDateValid ? (
        <FirmReferenceInfoBloc>
          <img src={InfoIcon} alt="InfoIcon" />
          <span style={{ margin: '5px' }}>
            {translate({ ...messages.firmReferenceInfoBloc }, props)}
          </span>
        </FirmReferenceInfoBloc>
      ) : (
        <>
          <span style={{ fontWeight: 'bold', fontSize: '18px' }}>{title}</span>

          <Container>
            {!(isFeeNoteGenerated && lawyerFirmReference !== null) &&
              !isPronoucing && (
                <>
                  <img src={InfoIcon} alt="InfoIcon" />
                  <MessageContainer>{message}</MessageContainer>
                </>
              )}
            <FormWrapper>
              <TextField
                label={formInputLabel}
                name={formInputName}
                value={newFirmReference}
                onChange={handleChangeFirmReference}
                InputProps={{
                  disabled:
                    (isFeeNoteGenerated && lawyerFirmReference !== null) ||
                    isPronoucing,
                }}
              />

              {!isFeeNoteGenerated && (
                <PrimaryButton
                  background={'#0075C9'}
                  titlecolor={'#FFFFFF'}
                  border={'#0075C9'}
                  title={validationButtonTitle}
                  disabled={!newFirmReference}
                  onClick={() =>
                    setIsDialogOpenFirmReference({
                      firmReference: newFirmReference,
                      isFeeNoteGenerated: isForm ? true : isFeeNoteGenerated,
                      judiciaryProcessId: props.judiciaryProcessId,
                      feeNote: {
                        ...feeNote,
                        assignment: {
                          id: get(props.assignment, 'id'),
                          firmReference: newFirmReference,
                        },
                        firmReference: newFirmReference,
                      },
                      lawyerFirmReference: lawyerFirmReference,
                    })
                  }
                />
              )}
            </FormWrapper>
          </Container>
        </>
      )}
    </>
  );
};

export default injectIntl(FirmReferenceForm);
